import {StringRule} from '../rules';

const fioPreset = new StringRule('Значение должно быть от :min до :max символов')
    .between(1, 255)
    .final();

export {fioPreset};
